import { Action } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { createRowNavigatePath } from "@/components/data-table/_helpers/create-row-navigate-path";
import { JobFunctionTable } from "@/components/data-table/predefined/job-function-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;

export function JobFunctionView() {
  const { t } = useTranslation(["common", "ram"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "JobFunction");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
        showRestore: false,
      };

  return (
    <Can I="read" a="JobFunction">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("ram:JobFunctions")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <JobFunctionTable
          pageSize={DEFAULT_PAGE_SIZE}
          showCreateButton={canManage}
          defaultRowActions={defaultRowActions}
          onRowNavigate={createRowNavigatePath("/masterdata/job-function")}
        />
      </CenteredLayout>
    </Can>
  );
}
